export default __webpack_public_path__ + "images/59cbebb97fce9742ccbefa46f5f930c8-2_mobile_659x494.jpg";